import React from 'react';

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({ title, subtitle, actions }) => (
  <header className="hf-page-header">
    <div style={{ minWidth: 0 }}>
      {typeof title === 'string' ? <h1 className="hf-page-title">{title}</h1> : title}
      {subtitle && <p className="hf-page-sub">{subtitle}</p>}
    </div>
    {actions && <div className="hf-page-actions">{actions}</div>}
  </header>
);

export default PageHeader;
